import { SagaIterator } from "@redux-saga/core";
import { startSubmit, stopSubmit } from "redux-form";
import { call, put, takeLatest } from "redux-saga/effects";

import { drugSearchActions } from "@/App/actions";
import { PageAlert } from "@/App/components";
import { ActionTypes } from "@/App/constants/actionTypes";
import apiService from "@/App/service";
import { DrugTypes } from "@/types";

function* searchForSelectedDrugs(data: DrugTypes.DrugSearchOptions): Generator {
  return yield apiService({
    url: "/mddb/drug/list",
    method: "POST",
    data,
  });
}

export function* searchForSelectedDrugsWorker(action: ReturnType<typeof drugSearchActions.searchForSelectedDrugs>): SagaIterator {
  const { searchForSelectedDrugsResults } = drugSearchActions;
  const { payload, formName } = action;
  const { showPageAlert } = PageAlert;

  try {
    yield put(startSubmit(formName));
    const ndcs = payload.map((drug: DrugTypes.DrugResult) => drug.ndc);
    const { results } = yield call(searchForSelectedDrugs, { ndc_list: ndcs });
    const drugs = results.map((result: DrugTypes.DrugSearchResult) => result.drug);
    yield put(searchForSelectedDrugsResults(drugs));
    yield put(stopSubmit(formName));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(stopSubmit(formName));
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* selectedDrugSearchWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.SEARCH_FOR_SELECTED_DRUGS, searchForSelectedDrugsWorker);
}
